import React from "react";
import { Row, Col} from "shards-react";

const Table4 = (props) => {
  return (
    <Row>
      <Col md="12" style={{ padding: "15px" }}>
        <h3>กรุณาเพิ่ม ข้อมูลต่างๆ ในตัวชี้วัดที่ 5 : จำนวนบุคลากรด้านเทคโนโลยีโลจิสติกส์โดยเฉพาะระดับหัวหน้างาน เจ้าหน้าที่เทคนิค และปฏิบัติการตามหลักสูตรมาตรฐาน</h3>
      </Col>
    </Row>
  );
};

export default Table4;
